import { createSlice } from '@reduxjs/toolkit';
import {
  deleteReminder,
  getLatestReminders,
  getReminders,
  saveReminder,
} from './remindersActions';

const initialState = {
  loading: false,
  reminders: [],
  latestReminders: [],
  error: null,
  success: false,
};

const remindersSlice = createSlice({
  name: 'reminders',
  initialState,
  reducers: {},
  extraReducers: {
    // get reminders
    [getReminders.pending]: state => {
      state.loading = true;
    },
    [getReminders.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.reminders = payload.data;
    },
    [getReminders.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // get latest reminders
    [getLatestReminders.pending]: state => {
      state.loading = true;
    },
    [getLatestReminders.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.latestReminders = payload.data;
    },
    [getLatestReminders.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // save reminder
    [saveReminder.pending]: state => {
      // state.loading = true;
    },
    [saveReminder.fulfilled]: (state, { payload }) => {
      state.loading = false;
      // state.docs = payload.data;
    },
    [saveReminder.rejected]: (state, { payload }) => {
      state.loading = false;
      // state.error = payload;
    },
    // delete reminder
    [deleteReminder.pending]: state => {
      // state.loading = true;
    },
    [deleteReminder.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [deleteReminder.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});
export default remindersSlice.reducer;
